export const ABOUT_DATA = {
  mission: {
    title: {
      fr: 'Mission',
      ar: 'رسالة المدرسة',
      en: 'Mission',
    },
    content: {
      fr: `L’école Girard est un établissement scolaire qui s’engage à :</br>
• Créer une atmosphère favorisant la créativité et l’innovation chez les élèves.</br>
• Ancrer dans leur esprit des principes de discipline, de bonne conduite et de patriotisme.</br>
• Approfondir les valeurs des relations humaines et du travail collectif.</br>
• Communiquer avec le monde extérieur à travers l’Internet.</br>
• Permettre aux élèves de passer de la phase d’instruction par enseignement à la phase incessante d’auto apprentissage.</br>
• Accorder une importance particulière aux activités éducatives, sportives, culturelles et sociales.</br>
• Encourager la participation active des parents au développement de la performance scolaire.</br>
• Encourager les enseignants à développer leurs compétences dans un cadre de formation continue.</br>
• Poursuivre le développement persistant de l’école conformément aux normes nationales de qualité.</br>
`,
      ar: `</br>تهيئة مناخ يساعد الطالبات على الإبداع والابتكار
       </br>تأصيل الاتجاهات السلوكية والوطنية والأخلاقية لدى الطالبات 
       </br>إرساء قواعد العلاقات الإنسانية والعمل الجماعى
        </br>التواصل مع العالم الخارجى من خلال شبكة الإنترنت 
        </br>مساعدة الطالبات على الانتقال من مرحلة التعليم إلى مرحلة التعلم مدى الحياة
        </br>الاهتمام بالأنشطة التربوية و الرياضية والثقافية والإجتماعية
        </br>تشجيع أولياء الأمور المهتمين بالعملية التعليمية على المشاركة فى تطور أداء المدرسة
        تشجيع المعلمين على التنمية المهنية المستدامةأن يكون تطوير المدرسة مستمراً وفقاً للمعايير القومية للجودة`,
      en: `• Create an atmosphere conducive to creativity and innovation among
 students.</br>
• Anchored in students' minds the principles of discipline, good conduct and
patriotism.</br>
• Deepen the values of human relations and teamwork.</br>
• Communicate with the outside world through the Internet.</br>
• Allow students to move from the phase of instruction by teaching the
 incessant self-learning phase.</br>
• Pay particular attention to educational, sports, cultural and social.</br>
• Encourage the active participation of parents in the development of
 academic performance.</br>
• Encourage teachers to develop their skills within a framework of lifelong
learning.</br>
• Continue the ongoing development of the school in accordance with
 national quality standards.</br>
`,
    },
    image: 'Mission.jpg',
  },
  contact: {
    address: {
      fr: '8 Rue Gaber El Ghazaly, Stanely',
      en: '8 Gaber El Ghazaly Street, Stanly',
      ar: '8 ش جابر الغزالى‎ ستانلى،',
    },
    phone: '+203 5420137 / +203 5420137',
    mail: 'info@ecole-girard.net',
    facebook: 'https://www.facebook.com/Ecole.Girard.Alexandria',
    twitter: 'https://x.com/EcoleGirard',
    youtube: 'https://www.youtube.com/user/EcoleGirard',
    instagram:
      'https://www.instagram.com/explore/locations/1019866531/ecole-girard---alexandrie/',
    linkedIn: 'https://www.linkedin.com/',
  },
  history: [
    {
      title: {
        fr: 'Historique',
        ar: 'تاريخ المدرسة',
      },
      description: {
        fr: `Fondé par Aimé-Antonin Girard il y a plus d’un siècle, l’établissement est une des plus anciennes écoles de langue. Elle est considérée comme le phare de la culture, de la science et de l’éducation à Alexandrie.`,
        ar: `تعد مدرسة جيرار منارة للثقافة والعلم والتربية وتمثل واحدة من أعرق مدارس اللغات فى الإسكندرية حيث تضرب بجذورها فى أراضى الاسكندرية منذ ما يزيد عن قرن من الزمان حيث استقر الأستاذ/جيرار بالإسكندرية فى القرن التاسع عشر وتحديداً فى عام الف وثمانية وتسعين للميلاد وأسس معهد جيرار الفرنسى ببوكلى`,
      },
      imageUrl: null,
      videoUrl: null,
    },
    {
      title: {
        fr: 'Qui est monsieur Aimé-Antonin Girard ?',
        ar: 'الأستاذ جيرار فى سطور',
      },
      description: {
        fr: `Officier de l’institution publique (janvier 1905)
Chevalier de l’Ordre Impérial de l’Osmanlie
Ancien chef d’Institution, Lauréat du conservatoire de musique
Ex-directeur des études françaises au collège grec-catholique à Beyrouth et en Syrie
Ex-directeur des études françaises à l’Université Américaine à Beyrouth et en Syrie
Ex-secrétaire chancelier du Consulat Général des Pays-Bas à Beyrouth et en Syrie
Ex-gérant du Consulat Général de Roumanie en Syrie et en Palestine
Ex-chirurgien aide-major à l’armée de la Loire durant la guerre de 1870-1871
Enseignant de langues vivantes, de mathématiques, de comptabilité
Enseignant du latin par une méthode simple
Enseignant de cours simultané d’histoire, de géographie, littérature et mythologie`,
        ar: `استقر بعد رحلة طويلة بالإسكندرية 1890كان يشغل منصب موظف بالتعليم العام يناير 1905حصل على درجة فارس من الأمبرطورية العثمانيةأحد الرواد المؤسسين لمعهد الموسيقىالمدير السابق للدراسات الفرنسية بالجامعة الأمريكية بيروت وسورياسكرتير الرئيس السابق للقنصلية الهولندية ببيروتالمفوض السابق للقنصلية الرومانية العامة فى فلسطين وسو ريامساعد جراح فى الجيش العثمانى فى حرب اللوار 1870ـ1871أستاذ اللغات الحية والرياضيات والمحاسبةمدرس اللغة اللاتينية بطريقة بسيطة وسهلة وسريعةحصص متزامنة فى التاريخ والجغرافيا والأدب والمثيولوجيا أي علم الأساطيرحصل على شهادة تركيا من الدرجة الأولى`,
      },
      imageUrl: null,
      videoUrl: 'NBq0KX4zfKo',
    },
    {
      title: {
        fr: 'Histoire et objectifs de l’établissement',
        ar: 'أهداف المؤسس',
      },
      description: {
        fr: `En 1890, Aimé-Antonin Girard vint s’installer à Alexandrie et ouvrit à Bulkley l’institution française Girard. D’année en année l’école progressa sous sa direction avec l’aide de sa femme madame Girard.`,
        ar: `كان الأستاذ إيميه انتونين جيرار يهدف من إنشاء المعهد إلى بناء الإنسان علمياً ووجدانياً وانسانيا ثم تولت أخته تيريز جيرار إدارة المدرسة بعد وفاته وساعدتها فى الإدارة أختها الثانية مارى لويز دوفونسيكا، وعندما بلغت الأختان السبعين من عمريهما بحثتا عمن يدير المدرسة واستقر بهما الأمر إلى الإتفاق مع الراهبات على إدارة المدرسة 1951 حيث تم توقيع العقود رسميا فى يوليو 1951`,
      },
      imageUrl: null,
      videoUrl: null,
    },
    {
      title: {
        fr: 'Les objectifs de l’institution étaient :',
        ar: 'ومن أبرز الأحداث التاريخية للمدرسة',
      },
      description: {
        fr: `Former les intelligences
diriger vers le bien les cœurs et les esprits.
A la mort de monsieur Girard, sa fille mademoiselle Thérèse Girard prit la direction. Plus tard, sa sœur madame Marie-Louise de Fonseca l’aida dans la direction. Dès 1949, toutes deux très âgées (70 ans environ), cherchaient une congrégation pour prendre en charge l’école afin de continuer leur œuvre. En juillet, en 1951, on tombe d’accord pour la passation de l’école aux sœurs franciscaines de Marie.`,
        ar: `زيارة جلالة الملك فؤاد الأول يوم السبت العاشر من نوفمبر 1921.
        زيارة معالى رئيس وزراء مصر الأسبق نجيب الهلالى باشا 1944
زيارة دكتور طه حسين وزير المعارف وعميد جامعة فاروق بصحبة عبد الخالق حسونة باشا محافظ الأسكندرية
منزل الراهبات. لمشاهدة الصور اضغط هناصور الإحتفال بمئوية المدرسة – 29 ابريل 2010
فندق جولي فيل – رامادا سابقاً
لمشاهدة الصور اضغط هنا`,
      },
      imageUrl: null,
      videoUrl: 'wHs0Rt6Ka4U',
    },
    {
      title: {
        fr: 'Parmi les événements historiques les plus importants :',
        ar: '',
      },
      description: {
        fr: `Visite de Sa Majesté le Roi Fouad 1er le samedi 10 novembre 1921. Visite du ministre de l’institution publique Naguib El HELALAI Pacha, du recteur de l’université Farouk 1er Taha HUSSEIN et du gouverneur d’Alexandrie Abdel Khalek HASSOUNA le 22 janvier 1944.
        Maison des soeurs. Pour voir les photos: cliquez ici
Centenaire de l’établissement – 29 avril 2010 – hôtel Jolie Ville (Ramada).
Pour voir les photos: cliquez ici`,
        ar: `منزل الراهبات. لمشاهدة الصور اضغط هناصور الإحتفال بمئوية المدرسة – 29 ابريل 2010
فندق جولي فيل – رامادا سابقاً
لمشاهدة الصور اضغط هنا`,
      },
      imageUrl: null,
      videoUrl: 'M_OpzlYv68M',
    },
  ],
  tour: {
    videoUrl: '6hJeV7iO-ys',
  },
  staff: {
    yearPhoto: 'yearPhoto.jpg',
    staffDetails: [
      { image: 'team-1.jpg', name: 'Name1', job: 'Job1' },
      { image: 'team-2.jpg', name: 'Name2', job: 'Job2' },
      { image: 'team-3.jpg', name: 'Name3', job: 'Job3' },
      { image: 'team-1.jpg', name: 'Name4', job: 'Job4' },
      { image: 'team-2.jpg', name: 'Name5', job: 'Job5' },
      { image: 'team-3.jpg', name: 'Name6', job: 'Job6' },
    ],
    formation: [
      {
        title: {
          fr: 'éminaire bilingue, organisé au Caire par l’Institut français du Caire : 11 et le 12 septembre 2022',
          ar: 'مؤتمر المدارس الفرنكفونية ثنائية اللغة : 11 و 12 من سبتمبر 2022',
        },
        description: {
          fr: `- Mme Mervat Barsoum, proviseure adjointe, ainsi qu’un groupe de coordinateurs et de professeurs de l’école , ont participé au séminaire bilingue, organisé au Caire par l’Institut français le 11 et le 12 septembre 2022.
Étaient presents au Séminaire M. Marc Barety, Ambassadeur de France, Monsieur David Sadoulet, directeur de l’Institut français du Caire et Madame Christine Gourjux, attachée de coopération pour le français, ainsi que plusieurs intervenants français.
Pour voir les photos, cliquez ici.`,
          ar: `شاركت أ/ ميرفت برسوم، وكيلة المدرسة، بالإضافة إلى مجموعة من منسقي مواد ومعلمات المدرسة في بمؤتمر المدارس الفرنكفونية ثنائية اللغة والتي نظمها المعهد الفرنسي بالقاهرة يومي 11 و 12 من سبتمبر 2022.
وحضر المؤتمر أ/ مارك باريتي، سفير فرنسا، وأ/ دافيد سادوليه، مدير المعهد الفرنسي بالقاهرة، وأ/ كريستين غورجو، ملحقية التعاون الفرنسي، فضلا عن عدة متحدثين بالفرنسية.
لمشاهدة الصور، اضغط هنا`,
        },
        imageUrl: null,
        videoUrl: null,
      },
      {
        title: {
          fr: 'Atelier destiné aux personnels d’encadrement des écoles labellisées : 15 septembre 2022',
          ar: 'ورشة عمل للمدارس الحاصلة على شهادة الجودة والاعتماد الفرنسية: 15 من سبتمبر 2022',
        },
        description: {
          fr: `animé à Girard le 15 septembre 2022 par Mme Catherine Blons – Pierre, (missionnaire FEi), Docteure en lettres et civilisation françaises et possède un Master 2 en sciences du langage, didactique du français langue étrangère (FLE) / Responsable de l’unité Expertise et qualité au sein du Département langue française de France Éducation International.
Pour voir les photos, cliquez ici.`,
          ar: `ورشة عمل لموظفي إدارة المدرسة أدارتها أ/ كاثرين بلونز – بيير (دكتوراة في الآداب والحضارة الفرنسية / ماجستير 2 في علوم اللغة “Didactique du français langue étrangère (FLE)” / رئيس وحدة الخبرة والجودة داخل قسم اللغة الفرنسية في France Éducation International) في جيرار في 15 من سبتمبر 2022 للمدارس الحاصلة على شهادة الجودة والاعتماد الفرنسية.
لمشاهدة الصور، اضغط هنا`,
        },
        imageUrl: null,
        videoUrl: null,
      },
      {
        title: {
          fr: 'Le comité de formation du SGEC à Alexandrie',
          ar: 'لجنة تدريب الأمانة العامة للمدارس الكاثوليكية يالإسكندرية',
        },
        description: {
          fr: `- Le 18 et le 19 septembre 2022 a eu lieu à Girard la formation à « L’éducation positive », animée par Gaelle MACERA. La formation est organisée par le comité de formation pour le français du SGEC à Alexandrie, présidée par Mme Mervat Barsoum. Étaient présents pour l’ouverture de la formation: Père Antonios Ghattas et Père Michel Chafik, responsable des écoles catholiques à Alexandrie.
Pour voir les photos, cliquez ici
- Le Jeudi 22 septembre 2022 a eu lieu à Girard la formation intitulée « Individualiser Vs Personnaliser l’apprentissage », animée par Mlle Sara Maher, conseillère pédagogique à Girard. La formation est organisée par le comité de formation pour le français du SGEC à Alexandrie présidée par Mme Mervat Barsoum. La formation s’adresse aux professeurs des écoles francophones.
Pour voir les photos, cliquez ici

- Le Comité de formation du Secrétariat général des écoles catholiques a organisé à l’école Girard une formation intitulée « Hors du tourbillon ». La formation tourne autour du stress des enseignants, le 9/12/2022
Pour voir les photos, cliquez ici

- Formation journalisme animée par M. Thibault pour les professeurs écoles catholiques dans le cadre du plan de formation du comité de formation du SGEC présidé par Mme Mervat Barsoum (juin 2023).
Pour voir les photos, cliquez ici.

- Formation de préparation au DALF C2 organisée par le comité de formation pour le français des écoles catholique présidé par madame Mervat Barsoum, la formation se déroule à Girard (juin 2023).
Pour voir les photos, cliquez ici.`,
          ar: `- قامت لجنة تدريب الأمانة العامة للمدارس الكاثوليكية على اللغة الفرنسية بالإسكندرية بتنظيم تدريب «التعليم الإيجابي» في جيرار في 18 و 19 من سبتمبر 2022. وقد قام بالتدريب أ/ غايل ماسيرا.
والجدير بالذكر أن أ/ ميرفت برسوم، وكيلة مدرسة جيرار هي المسئولة عن اللجنة، وقد حضر الافتتاح الأب أنطونيوس غطاس، مدير مدرسة جيرار والأب ميشيل شفيق، المسؤول عن المدارس الكاثوليكية في الإسكندرية.
لمشاهدة الصور، اضغط هنا

- قامت لجنة تدريب الأمانة العامة للمدارس الكاثوليكية على اللغة الفرنسية بالإسكندرية برئاسة أ/ميرفت برسوم بتنظيم تدريب بعنوان «الفردية مقابل اضفاء الطابع الشخس في التعليم » بجيرار يوم الخميس 22 من سبتمبر 2022 وقد قام بالتدريب أ/سارة ماهر، المستشارة التربوية بجيرار. ويستهدف التدريب المدرسين في المدارس الناطقة بالفرنسية.

لمشاهدة الصور، اضغط هنا

- أقامت لجنة التدريب بالأمانة العامة للمدارس الكاثوليكية فى مدرسة جيرار تدريب بعنوان (برا الدوامة)، والذى تناول الضغوط النفسية التي يتعرض لها المدرسين، وذلك يوم 9/12/2022
لمشاهدة الصور، اضغط هنا

- تدريب حول الصحافة مع أ/تيبو لمعلمي المدارس الكاثوليكية كجزء من خطة التدريب للجنة التدريب SGEC برئاسة السيدة ميرفت برسوم: يونيو 2023
لمشاهدة الصور، اضغط هنا

- أقيم التدريب التحضيري لـ DALF C2 في جيرار وقد قام بتنظيمه لجنة تدريب اللغة الفرنسية للمدارس الكاثوليكية برئاسة م/ميرفت برسوم (يونيو 2023).
لمشاهدة الصور، اضغط هنا`,
        },
        imageUrl: null,
        videoUrl: null,
      },
      {
        title: {
          fr: 'Plan de formation de l’école élaboré pour les cadres de l’établissement ainsi que pour le corps enseignant (2022-2023)',
          ar: 'خطة المدرسة لتدريب كوادر المدرسة وأعضاء هيئة التدريس 2022-2023',
        },
        description: {
          fr: `Un plan de formation a été élaboré pour les cadres de l’établissement ainsi que pour le corps enseignant afin de maintenir le niveau de service éducatif qu’elle offre à ses élèves.
Ce plan vise à développer les compétences des enseignants et à maîtriser les nouveaux outils de communication avec les étudiantes (septembre 2022).
Pour voir les photos, cliquez ici.`,
          ar: `- وضعت المدرسة خطة لتدريب كوادر المدرسة واعضاء هيئة التدريس بها للحفاظ على مستوى الخدمة التعليمية التى تقدمها لطالباتها وتهدف هذه الخطة ﺇلى تنمية مهارات المعلمين والوقوف على أحدث وسائل التواصل مع الطالبات وذلك لما تتميز به المدرسة من مستوى تربوى وتعليمى عالٍ: سبتمبر 2022.
لمشاهدة الصور، اضغط هنا`,
        },
        imageUrl: null,
        videoUrl: null,
      },
      {
        title: {
          fr: 'L’IUFP (Institut universitaire de Formation des Professeurs) (2022-2023)',
          ar: 'المعهد الجامعي لتدريب المعلمين (IUFP) 2022-2023',
        },
        description: {
          fr: `L’IUFP (Institut universitaire de Formation des Professeurs) est un dispositif professionnalisant de l’IFE, créé en 2004, pour répondre à des demandes d’exigence de formation dans les écoles bilingues. Il existe un cursus de formation initiale destiné aux enseignants débutants ou peu expérimentés, un cursus de formation continue destiné aux enseignants.
Trois formatrices de l’école Girard à citer Mme Mervat BARSOUM, la proviseure-adjointe, Mme Sahar TADROS, responsable du cycle secondaire et coordinatrice de Maths – cycle secondaire et Mlle Marwa HOSSAM, coordinatrice de français langue seconde et conseillère des TICE ont été nommées formatrices par l’IUFP en 2021-2022.
En 2022-2023, le nombre de formatrices de Girard a augmenté à six: Mme Mervat BARSOUM, Mme Sahar TADROS, Mlle Marwa HOSSAM et les nouvelles formatrices, Mlle Héba ZAALOUK, enseignante documentaliste, Mlle Sara GUIRGUIS et Mme Mohga KHALED, coordinatrices de français.

Pour voir les photos, cliquez ici.`,
          ar: `المعهد الجامعي لتدريب المعلمين (IUFP) تم إنشاؤه في عام 2004 لتلبية متطلبات التدريب في المدارس ويوجد منهج تدريبي للمدرسين الجدد، وآخر للمعلمين ذو خبرة.
تم تعيين ثلاثة مدربات من مدرسة جيرار وهن أ/ ميرفت برسوم، وكيلة المدرسة، وأ/ سحر تادرس، رئيسة القسم الثانوي ومدرس أول مادة الرياضيات للمرحلة الثانوية، وأ/ مروى حسام، مدرس أول اللغة الفرنسية الثانية ومستشارة تكنولوجيا المعلومات والاتصالات بالمدرسة كمدربات في IUFP 2021-2022
وفي عام 2022-2023 انضم إلى المعهد ثلاثة مدربات من جيرار وهن أ/ هبة مسئولة المكتبة الفرنسية ومدرس أول لغة فرنسية وأ/ سارة ماهر مستشارة تربوية ومدرس أول لغة فرنسية وأ/ مهجة خالد مدرس أول لغة فرنسية
لمشاهدة الصور، اضغط هنا`,
        },
        imageUrl: null,
        videoUrl: null,
      },
    ],
    partners: [
      {
        title: {
          fr: 'Le protocole signé avec l’Université Française d’Égypte: juin 2022',
          ar: 'لبروتوكول الموقع مع جامعة مصر الفرنسية: يونيو 2022',
        },
        description: {
          fr: `Le samedi 11 juin 2022, un protocole de coopération a été signé entre l’École Girard et l’Université Française d’Égypte accordant aux élèves du 3e secondaire une déduction de 15% sur les frais de scolarité pour une période de 3 ans avec une possibilité de payer en mensualités pendant 10 mois sans intérêt.

Pour voir la nouvelle, cliquez ici.`,
          ar: `في يوم السبت 11 من يونيو 2022، تم توقيع بروتوكول تعاون بين مدرسة جيرار والجامعة الفرنسية المصرية يمنح طالبات الصف الثالث الثانوي خصمًا بنسبة 15٪ على الرسوم الدراسية لمدة 3 سنوات مع إمكانية الدفع على أقساط شهرية لمدة 10 أشهر بدون فوائد.

لقراءة الخبر، اضغط هنا`,
        },
        imageUrl: null,
        videoUrl: null,
      },
      {
        title: {
          fr: 'Le protocole signé avec la faculté de pédagogie section française: octobre 2022',
          ar: 'البروتوكول الموقع مع قسم كلية التربية الفرنسية: أكتوبر 2022.',
        },
        description: {
          fr: `– Pour la sixième année, un protocole est signé avec la faculté de pédagogie section francaise, pour que l’école accueille les étudiants de quatrième année comme stagiaires pour une année scolaire.

Pour voir les photos, cliquez ici.

– Père Antonios Ghattas directeur de l’école et madame Mervat Barsoum Proviseure adjointe ont accueilli le jeudi 16 novembre 2022 Dr. Mohamed Anouar, le doyen de la faculté de pédagogie, dans le cadre du protocole de formation des étudiants du département de français.
Pour voir les photos, cliquez ici.`,
          ar: ``,
        },
        imageUrl: null,
        videoUrl: null,
      },
      {
        title: {
          fr: 'Le protocole signé avec l’Université de Pharos: 16 novembre 2022.',
          ar: 'بروتوكول تعاون بين مدرسة جيرار وجامعة فاروس: 16 من نوفمبر 2022',
        },
        description: {
          fr: `Un protocole de coopération a été signé entre l’École Girard, représentée par Mme Mervat BARSOUM, la proviseure-adjointe avec l’Université de Pharos, représentée par Dr. Ramadan Abu AL-ELA, vice-président, en présence de Dr. Sahar HAMOUDA, doyen de la Faculté des Langues et de la traduction de l’Université de Pharos, et Dr. Héba REFAAT ELHATTAB, professeur au Département de la langue française, Faculté des langues et de la traduction, Université de Pharos, le mercredi 16 novembre 2022.
Pour voir les photos, cliquez ici.`,
          ar: `تم توقيع بروتوكول تعاون بين مدرسة جيرار الممثلة فى السيدة/ ميرفت برسوم وكيلة المدرسة، وجامعة فاروس الممثلة فى ا.د/ رمضان أبو العلا نائب رئيس الجامعة لشئون خدمة المجتمع وتنمية البيئة بجامعة فاروس، وذلك بحضور ا.د/ سحر حمودة عميدة كلية اللفات والترجمة جامعة فاروس، ود./هبة رفعت الحطاب مدرس بقسم اللغة الفرنسية بكلية اللغات والترجمة جامعة فاروس، وذلك يوم الأربعاء 16 نوفمبر.
لمشاهدة الصور، اضغط هنا`,
        },
        imageUrl: null,
        videoUrl: null,
      },
      {
        title: {
          fr: 'Le protocole signé avec la faculté Pharos : 15 décembre 2022',
          ar: 'بروتوكول جامعة فاروس: 15 من ديسمبر 2022',
        },
        description: {
          fr: `Pour la première année, un protocole est signé avec la faculté Pharos pour que l’école accueille les étudiants de troisième et quatrième année du département de langue française comme stagiaires durant cette année scolaire.
Pour voir les photos, cliquez ici.`,
          ar: ` تم توقيع بروتوكول مع هيئة التدريس جامعة فاروس لاستقبال طلاب الفرقتين الثالثث والرابعة للقسم الفرنسي للتدريب قي مدرسى جيرار خلال العام الدراسي الحالي.
لمشاهدة الصور، اضغط هنا`,
        },
        imageUrl: null,
        videoUrl: null,
      },
      {
        title: {
          fr: 'Le protocole signé avec l’Institut français d’Egypte pour la mise en place d’une section française internationale au cycle secondaire: mai 2021.',
          ar: 'البروتوكول الموقع مع المعهد الفرنسي المصري لإنشاء قسم فرنسي دولي في المرحلة الثانوية: مايو 2021.',
        },
        description: {
          fr: `Un protocole de partenariat a été signé entre l’Institut français d’Egypte et l’école en mai 2021 pour la mise en place d’une section française internationale au cycle secondaire pour l’année scolaire 2021-2022.

Pour voir la nouvelle, cliquez ici.`,
          ar: `تم توقيع بروتوكول شراكة بين المعهد الفرنسي المصري والمدرسة في مايو 2021 لإنشاء قسم دولي للمدرسة الثانوية الفرنسية للعام الدراسي 2021-2022.
لمشاهدة الخبر اضغط هنا`,
        },
        imageUrl: null,
        videoUrl: null,
      },
    ],
  },
};
